import { FC } from 'react'
import { IFrameComponent as IFrame } from 'features/IFrame'

export const withIFrameHOC =
  (Component: FC<any>): FC<any> =>
  props =>
    (
      <>
        <Component {...props}>
          <IFrame />
        </Component>
      </>
    )
